import { RefObject, useEffect, useState } from 'react';

export type UseScrollThresholdOptions = {
	rootRef?: RefObject<HTMLElement | null>;
	screenfuls?: number;
};

export const useScrollThreshold = ({ rootRef, screenfuls = 1 }: UseScrollThresholdOptions = {}) => {
	const [passed, setPassed] = useState(false);

	useEffect(() => {
		const el = rootRef?.current ?? null;
		let raf = 0;

		const getTop = () => (el ? el.scrollTop : window.scrollY || document.documentElement.scrollTop || 0);

		const getLimit = () => {
			const h = window.innerHeight;
			return h * screenfuls;
		};

		const update = () => {
			raf = 0;
			setPassed(getTop() > getLimit());
		};

		const onScroll = () => {
			if (raf) return;
			raf = requestAnimationFrame(update);
		};

		const target: any = el ?? window;
		target.addEventListener('scroll', onScroll, { passive: true });
		window.addEventListener('resize', onScroll);

		update();

		return () => {
			target.removeEventListener('scroll', onScroll);
			window.removeEventListener('resize', onScroll);
			if (raf) cancelAnimationFrame(raf);
		};
	}, [rootRef, screenfuls]);

	return passed;
};
